import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { PositionShowComponent } from '../position-show';
import { Position } from '@mri/types';

@Component({
  selector: 'app-position-dialog',
  standalone: true,
  imports: [
    PositionShowComponent,
    MatDialogContent,
    MatDialogTitle
  ],
  templateUrl: './position-dialog.component.html',
  styleUrl: './position-dialog.component.scss'
})
export class PositionDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { elementId: string, element: Position }
  ) {
  }
}
